var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('router-link',{attrs:{"to":{ name:'pdf-viewer',params: {url: _vm.href } }}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":"EyeIcon","size":"16"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }